import React, { useContext, useState } from 'react';

const TimeContext = React.createContext();
const TimeContextUpdate = React.createContext();

export function useTime() {
  return useContext(TimeContext);
}

export function useTimeUpdate() {
  return useContext(TimeContextUpdate);
}

export function TimeProvider({ children }) {
  const [granularity, setGranularity] = useState('year');
  const [currentDate, setCurrentDate] = useState('0');
  const [calendar, setCalendar] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [unitsDisplay, setUnitsDisplay] = useState(0);

  const updateScrollPosition = (newPos) => {
    setScrollPosition(newPos);
  };

  //Properties to pass to children
  const value = {
    granularity,
    currentDate,
    setGranularity,
    setCurrentDate,
    calendar,
    setCalendar,
    scrollPosition,
    updateScrollPosition,
    unitsDisplay,
    setUnitsDisplay,
  };

  return <TimeContext.Provider value={value}>{children}</TimeContext.Provider>;
}
